import {
  AfterViewInit,
  Component,
  OnInit,
  Directive,
  ViewChild,
  Inject,
} from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { Global } from "../../../global";
import { AuthenticationService } from "../../authentication/authentication.service";
import { AppHeaderService } from "../../header/app-header/app-header.service";
import { Router, ActivatedRoute } from "@angular/router";
import { PeopleService } from "../../people/people.service";
import { NavController } from "@ionic/angular";
import { FileService } from "src/app/services/file.service";
import {
  NetworkService,
  ConnectionStatus,
} from "../../services/network.service";
import { OfflineManagerService } from "../../services/offline-manager.service";
import { ModalComponent } from "src/app/modals/modal/modal.component";
import { ModalController } from "@ionic/angular";
import { NotificationsComponent } from "src/app/modals/modal/components/notifications/notifications.component";
import { NotificationService } from "src/app/modals/modal/components/notifications/notifications.service";
import { AppService } from "src/app/app.service";
declare var introJs: any;
import * as introJs from "intro.js/intro";
import { IntroService } from "src/app/services/intro.service";

import {
  MsalService,
  MsalBroadcastService,
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
} from "@azure/msal-angular";
import {
  AuthenticationResult,
  InteractionStatus,
  PopupRequest,
  RedirectRequest,
  EventMessage,
  EventType,
} from "@azure/msal-browser";

@Component({
  selector: "app-page-header",
  templateUrl: "./page-header.component.html",
  styleUrls: ["./page-header.component.scss"],
})
export class PageHeaderComponent implements OnInit, AfterViewInit {
  public PercentageDownloaded: any;
  public OnLine: boolean = false;
  public enablingOfflineButton: boolean = false;
  public lastUpdate: Date;
  unreadCount: number;
  incomplete: any[] = [];
  showBadge: boolean = false;
  notifications: any[] = [];
  lessonCount: number = 0;
  incompleteCount: number = 0;
  firstTwoNotifications: any[] = [];
  firstTwoIncomplete: any[] = [];

  constructor(
    public globals: Global,
    public authenticationService: AuthenticationService,
    private router: Router,
    private route: ActivatedRoute,
    private appHeaderService: AppHeaderService,
    public navCtrl: NavController,
    private networkService: NetworkService,
    private offlineManager: OfflineManagerService,
    public fileService: FileService,
    private modal: ModalComponent,
    private modalController: ModalController,
    private peopleService: PeopleService,
    private notificationService: NotificationService,
    private appservice: AppService,
    private introService: IntroService,
    @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) {}
  async openModal() {
    const modal = await this.modalController.create({
      component: ModalComponent,
      cssClass: "infoModal",
    });
    await modal.present();
  }

  getImageSrc(
    contentGUID: string | null | undefined,
    fallbackImage: string
  ): string {
    if (!contentGUID || contentGUID.trim() === "") {
      return `assets/CustomContent/Thumbnails/${fallbackImage}`;
    }
    return (
      this.globals.GetXRSCustomContentURL() +
      "Thumbnails/" +
      contentGUID +
      ".jpg"
    );
  }

  async notificationModal() {
    const modal = await this.modalController.create({
      component: NotificationsComponent,
      cssClass: "notifications",
    });
    await modal.present();
  }

  async ngAfterViewInit() {
    try {
      this.lastUpdate = await this.offlineManager.getLocalData(
        "LastOfflineStorageDate"
      );
    } catch (error) {
      console.log(error);
    }
    this.fileService
      .getPercentageFilesDownloadedValue()
      .subscribe(async (value) => {
        this.PercentageDownloaded = value;
        if (this.PercentageDownloaded >= 100) {
          this.enablingOfflineButton = false;
          this.lastUpdate = await this.offlineManager.getLocalData(
            "LastOfflineStorageDate"
          );
        }
      });
    this.networkService
      .onNetworkChange()
      .subscribe((status: ConnectionStatus) => {
        if (status === ConnectionStatus.Online) {
          this.offlineManager.checkForEvents().subscribe();
          //this.fileService.deleteFolder('STSContent');
          this.OnLine = true;
        } else {
          this.OnLine = false;
        }
      });
  }

  ngOnInit() {
    this.OnLine = navigator.onLine;
    window.addEventListener("online", this.updateOnlineStatus.bind(this));
    window.addEventListener("offline", this.updateOnlineStatus.bind(this));

    // this.notificationList();
    // this.incompleteLessonList();

    this.notificationService.badgeState$.subscribe((state) => {
      this.showBadge = state;
    });

    // const steps = [
    //   { element: "#step2", intro: "What's new...", order: 2 },
    //    { element: "#step5", intro: "Info button", order: 5 },
    // ];
    // this.introService.addSteps(steps);
  }

  notificationList() {
    const formData: FormData = new FormData();
    formData.append("User_GUID", this.globals.XRSUser.GUID);
    formData.append("User_Token", this.globals.XRSUser.UserToken);

    this.appservice.GetNotificationList(formData).subscribe((res) => {
      
      try {
        this.notifications = JSON.parse(res);
        this.lessonCount = this.notifications.length;
        this.firstTwoNotifications = this.notifications.slice(0, 2);
        this.updateBadgeStatus();
      } catch (e) {
        console.error(e);
      }
    });
  }

  incompleteLessonList() {
    const formData: FormData = new FormData();
    formData.append("User_GUID", this.globals.XRSUser.GUID);
    formData.append("User_Token", this.globals.XRSUser.UserToken);

    this.appservice.GetIncompleteLessonList(formData).subscribe((res) => {
      
      try {
        this.incomplete = JSON.parse(res);
        this.incompleteCount = this.incomplete.length;
        this.firstTwoIncomplete = this.incomplete.slice(0, 2);
        this.updateBadgeStatus();
      } catch (e) {
        console.error(e);
      }
    });
  }

  updateBadgeStatus() {
    const showBadge =
      (this.notifications && this.notifications.length > 0) ||
      (this.incomplete && this.incomplete.length > 0) ||
      (this.notifications &&
        this.notifications.length > 0 &&
        this.incomplete &&
        this.incomplete.length > 0);
    this.notificationService.setBadgeState(showBadge);
  }

  logOut() {
    localStorage.removeItem("menuState");
    localStorage.removeItem("selectedPageUrl");
    //Multi frontend : clear all the storage that might compromise secuity and go back to base url
    localStorage.removeItem("IsAuthenticated");
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";

    this.router.navigateByUrl("/login");
    this.authenticationService.logout();
  }

  async enableOffline() {
    await this.modal
      .show(
        "confirm",
        "Download Offline Data",
        "This operation downloads all required files for offline training. Please ensure a stable connection to online server. Do you wish to continue?"
      )
      .then((dataReturned: any) => {
        if (dataReturned.data == true) {
          //this.globals.OfflineEnabled = true;
          this.enablingOfflineButton = true;
          console.log("status in page-header.component", status);
          this.offlineManager.checkForEvents().subscribe();

          this.fileService.downloadUserTrainingData(this.globals.XRSUser.GUID);
          //this.fileService.deleteFolder('STSContent');
          this.fileService.downloadUserLessonsContent(
            this.globals.XRSUser.GUID
          );
        }
      });
  }

  updateOnlineStatus(): void {
    this.OnLine = navigator.onLine;
  }

  navigateToPeoplePage() {
    // this.appHeaderService.setByUrl("../../people/people-edit");
    // this.navCtrl.navigateRoot(["../../people/people-edit"], {
    //   queryParams: { displayState: "normal", GUID: this.globals.XRSUser.GUID },
    // });

    this.appHeaderService.setByUrl(
      "../../peopleSimplified/peopleSimplified-edit"
    );
    this.navCtrl.navigateRoot(
      ["../../peopleSimplified/peopleSimplified-edit"],
      {
        queryParams: {
          displayState: "normal",
          GUID: this.globals.XRSUser.GUID,
        },
      }
    );

    this.peopleService.setNavigatedFromLink("/home");

    //this.router.navigate(['../../people/people-edit'], { queryParams: { displayState: "normal", GUID:this.globals.XRSUser.GUID} });
  }
}
